import { initStore } from '../useStore';

const configStore = () => {
  const actions = {
    SET: (curState, newState) => {
      // console.log('newState', newState);
      return { ...curState, ...newState };
    },
    RESET_MESSAGES: (curState) => {
      return {
        ...curState,
        // showTicketMessage: false,
        showGroupMessage: false,
        showMaxMessage: false,
        showNoParkingMessage: false,
        showAvailabilityMessage: false,
        showMonthAvailabilityMessage: false
      }
    }
  };
  initStore(actions, {
    section: null,
    wW: null,
    pageTitle: '',
    step: 0,
    stepped: 0,
    stepNames: [],
    customFields: null,
    showLoader: true,
    rowDelay: 150,
    initCalendar: false,
    showCalendar: true,
    showTicketMessage: false,
    familyTicketMessage: '',
    showGroupMessage: false,
    showMaxMessage: false,
    showAvailabilityMessage: false,
    showMonthAvailabilityMessage: false,
    showRedeemedMessage: false,
    showImageLightbox: false,
    dayMaxed: false,
    firstAvailLabel: 'First available Studio Tour is ',
    dateTimeLabelFirst: 'The first available date & time is:',
    dateTimeLabelSelected: 'Your selected date & time is:',
    prevSection: null,
    parkingMaxed: false,
    isCrossSell: false,
    updateCart: false,
    timerActive: false,
    confirmTimeChange: false,
    dateTimeConfirmed: false,
    buttonDisabled: false,
    giftAddonSelected: false,
    lightBoxImageUrl: null,
    isUS: false,
    sameAddress: false,
    paymentSubmitted: false,
    billingIsSet: false
  });
};

export default configStore;
